import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './../Maintenance/Maintenance.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import {CreateTable} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function TaxNew({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Annual Income Range From",
        "Annual Income Range From",
        "Tax Percentage",
        "Excess",
        "",
    ]
    var accessor = [
        "id",
        "annualIncomeRangeFrom",
        "annualIncomeRangeTo",
        "percentage",
        "excess",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [tax, setTax] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("pay type");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [annualIncomeRangeFrom, setAnnualIncomeRangeFrom] = useState("");
    const [annualIncomeRangeTo, setAnnualIncomeRangeTo] = useState("");
    const [percentage, setPercentage] = useState("");
    const [excess, setExcess] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState([]);
    const [editAnnualIncomeRangeFrom, setEditAnnualIncomeRangeFrom] = useState("");
    const [editAnnualIncomeRangeTo, setEditAnnualIncomeRangeTo] = useState("");
    const [editPercentage, setEditPercentage] = useState("");
    const [editExcess, setEditExcess] = useState("");
    //Old
    const [oldEditAnnualIncomeRangeFrom, setOldEditAnnualIncomeRangeFrom] = useState("");
    const [oldEditAnnualIncomeRangeTo, setOldEditAnnualIncomeRangeTo] = useState("");
    const [oldEditPercentage, setOldEditPercentage] = useState("");
    const [oldEditExcess, setOldEditExcess] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/TaxNew";
    
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setTax(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("pay type")
                break;
            case 1:
                setSearchPlaceholder("tax id")
                break;
            default:
                setSearchPlaceholder("pay type")
                break;
        }
    }, [fetchData, filterDataIndex]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.payTypeDescription.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.payTypeDescription.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setTax(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            annualIncomeRangeFrom: annualIncomeRangeFrom,
            annualIncomeRangeTo: annualIncomeRangeTo ? annualIncomeRangeTo : 0,
            percentage: percentage ? percentage : 0,
            excess: excess ? excess : 0,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Tax", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setAnnualIncomeRangeFrom("");
            setAnnualIncomeRangeTo("");
            setPercentage("");
            setExcess("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            annualIncomeRangeFrom: editAnnualIncomeRangeFrom,
            annualIncomeRangeTo: editAnnualIncomeRangeTo ? editAnnualIncomeRangeTo : 0,
            percentage: editPercentage ? editPercentage : 0,
            excess: editExcess ? editExcess : 0,
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.annualIncomeRangeFrom !== oldEditAnnualIncomeRangeFrom){
                auditInfo.push({
                    setupArea: "Tax",
                    actionTaken: "update",
                    field: "Annual Income Range From",
                    newValue: `${data.annualIncomeRangeFrom}`,
                    oldValue: `${oldEditAnnualIncomeRangeFrom}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.annualIncomeRangeTo !== oldEditAnnualIncomeRangeTo){
                auditInfo.push({
                    setupArea: "Tax",
                    actionTaken: "update",
                    field: "Annual Income Range To",
                    newValue: `${data.annualIncomeRangeTo}`,
                    oldValue: `${oldEditAnnualIncomeRangeTo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.percentage !== oldEditPercentage){
                auditInfo.push({
                    setupArea: "Tax",
                    actionTaken: "update",
                    field: "Percentage",
                    newValue: `${data.percentage}`,
                    oldValue: `${oldEditPercentage}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.excess !== oldEditExcess){
                auditInfo.push({
                    setupArea: "Tax",
                    actionTaken: "update",
                    field: "Excess",
                    newValue: `${data.excess}`,
                    oldValue: `${oldEditExcess}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditAnnualIncomeRangeFrom("");
            setEditAnnualIncomeRangeTo("");
            setEditPercentage("");
            setEditExcess("");
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditAnnualIncomeRangeFrom(data.annualIncomeRangeFrom);
        setEditAnnualIncomeRangeTo(data.annualIncomeRangeTo);
        setEditPercentage(data.percentage);
        setEditExcess(data.excess);
        setOldEditAnnualIncomeRangeFrom(data.annualIncomeRangeFrom);
        setOldEditAnnualIncomeRangeTo(data.annualIncomeRangeTo);
        setOldEditPercentage(data.percentage);
        setOldEditExcess(data.excess);
        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo shadow-xl">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Government Premiums >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"BIR / Tax"}</span>
                            </div>
                            <h3>BIR / Tax</h3>
                        </div>
                        <div className="mainte-body">
                            <div style={{display: "none"}}>
                                {Filter(setFilterDataIndex)}
                            </div>
                            <div className="mainte-body-top">
                                <div className="mainte-addBtn row" style={{justifyContent: "start"}}>
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="mainte-body-top row" style={{display: "none"}}>
                                {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e)=>handleFilter(e.target.value), "Search by " + searchPlaceholder, SearchIcon)}

                                <div className="mainte-addBtn row">
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={tax}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    annualIncomeRangeFrom={annualIncomeRangeFrom}
                    annualIncomeRangeTo={annualIncomeRangeTo}
                    percentage={percentage}
                    excess={excess}
                    setAnnualIncomeRangeFrom={setAnnualIncomeRangeFrom}
                    setAnnualIncomeRangeTo={setAnnualIncomeRangeTo}
                    setPercentage={setPercentage}
                    setExcess={setExcess}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editAnnualIncomeRangeFrom={editAnnualIncomeRangeFrom}
                    editAnnualIncomeRangeTo={editAnnualIncomeRangeTo}
                    editPercentage={editPercentage}
                    editExcess={editExcess}
                    setEditAnnualIncomeRangeFrom={setEditAnnualIncomeRangeFrom}
                    setEditAnnualIncomeRangeTo={setEditAnnualIncomeRangeTo}
                    setEditPercentage={setEditPercentage}
                    setEditExcess={setEditExcess}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({isOpen, 
    onClose,
    annualIncomeRangeFrom,
    annualIncomeRangeTo,
    percentage,
    excess,
    setAnnualIncomeRangeFrom, 
    setAnnualIncomeRangeTo, 
    setPercentage, 
    setExcess, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!annualIncomeRangeFrom 
            || !annualIncomeRangeTo 
            || !percentage 
            || !excess 
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };
    const handleClose = () => {
        onClose();
        setAnnualIncomeRangeFrom("");
        setAnnualIncomeRangeTo("");
        setPercentage("");
        setExcess("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Tax</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Annual Income Range From</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="Annual Income Range From"
                                    placeholder="Annual Income Range From"
                                    value={annualIncomeRangeFrom}
                                    onChange={(e) => setAnnualIncomeRangeFrom(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !annualIncomeRangeFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Annual Income Range To</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="annualIncomeRangeTo"
                                    placeholder="Annual Income Range To"
                                    value={annualIncomeRangeTo}
                                    onChange={(e) => setAnnualIncomeRangeTo(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !annualIncomeRangeTo && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Percentage</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="percentage"
                                    placeholder="Percentage"
                                    value={percentage}
                                    onChange={(e) => setPercentage(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !percentage && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Excess</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="excess"
                                    placeholder="Excess"
                                    value={excess}
                                    onChange={(e) => setExcess(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !excess && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
                )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose,  
    editAnnualIncomeRangeFrom, 
    editAnnualIncomeRangeTo, 
    editPercentage, 
    editExcess, 
    setEditAnnualIncomeRangeFrom,
    setEditAnnualIncomeRangeTo,
    setEditPercentage,
    setEditExcess,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editAnnualIncomeRangeFrom 
            || !editAnnualIncomeRangeTo
            || !editPercentage
            || !editExcess
        ){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };
    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Tax</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Annual Income Range From</div>
                                <div className="info-item-input">
                                    <input
                                    id="annualIncomeRangeFrom"
                                    placeholder="Annual Income Range From"
                                    value={editAnnualIncomeRangeFrom}
                                    onChange={(e) => setEditAnnualIncomeRangeFrom(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !editAnnualIncomeRangeFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Annual Income Range To</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="annualIncomeRangeTo"
                                    placeholder="Annual Income Range To"
                                    value={editAnnualIncomeRangeTo}
                                    onChange={(e) => setEditAnnualIncomeRangeTo(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                    visibility: !editAnnualIncomeRangeTo && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="info-item-holder row">
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Percentage</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="percentage"
                                    placeholder="Percentage"
                                    value={editPercentage}
                                    onChange={(e) => setEditPercentage(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                    visibility: !editPercentage && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Excess</div>
                                <div className="info-item-input">
                                    <input
                                    type="number"
                                    id="excess"
                                    placeholder="Excess"
                                    value={editExcess}
                                    onChange={(e) => setEditExcess(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                    visibility: !editExcess && errorState ? "visible" : "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "TaxId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="TaxId">Tax Id</option>
            </select>
        </div>
    );
};
export default TaxNew
